import React, { ReactNode } from 'react'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import { Subtitle } from '../../typography'

type Props = {
    children?: ReactNode
    className?: string
    field: CreationToolSuperCutField
}

const CreationSuperCutFieldTitle = ({ children, className, field }: Props) => {
    const title = CreationToolSuperCutField.title(field)
    return (
        <Subtitle className={className}>
            {title}
            {children}
        </Subtitle>
    )
}

export default CreationSuperCutFieldTitle
